<!--
  No `background-color` here, deliberately.

  Paper-white behind the artwork is painted by `paintCoverWhitePlate`
  (service-ui/cover-white-plate.ts), which sizes it to the artwork alone.
  `background` on a replaced element covers the whole padding box, so a static
  `background-color: white` would also fill any space the artwork does not
  reach -- and that space is panel, not paper. See the backdrop note in the
  thumbnail CSS.
-->
<img #draftCoverImage src=""
     [style.max-width.px]="width"
     [style.min-height.px]="height"
     [style.max-height.px]="height"
     style="display: block; width: 436px; height: 304px; object-fit: cover;"
     (load)="onCoverImageLoaded()"
     class="image" alt="">
